export default "__VITE_ASSET__CWLsNJDQ__"